import React from "react";
import cn from "classnames";
import styles from "./Loader.module.scss";

export interface ILoaderProps {
  mode?: "light" | "dark";
}

export const Loader = ({ mode = "light" }: ILoaderProps): JSX.Element => {
  return (
    <div
      className={cn(styles.wrapper, {
        [styles.dark]: mode === "dark",
      })}
    >
      <div className={styles.bar} />
    </div>
  );
};
